import React from 'react';
import { useLessonContext } from '../../LessonContext';
import { PipelineCard, PipelineCardStatus } from '../../shared/PipelineCard';

interface LessonPipelineStage {
  id: string;
  name: string;
}

const LESSON_STAGES: LessonPipelineStage[] = [
  { id: 'lesson_setup', name: 'Lesson Setup' },
  { id: 'lesson_generation', name: 'Lesson Generation' },
  { id: 'lesson_review', name: 'Lesson Review' },
  { id: 'lesson_exercise_gen', name: 'Exercise Generation' },
  { id: 'lesson_exercise_review', name: 'Exercise Review' },
  { id: 'lesson_image_gen', name: 'Image Generation' },
  { id: 'lesson_audio_gen', name: 'Audio Generation' },
  { id: 'lesson_preview', name: 'Preview' },
  { id: 'lesson_compile', name: 'Compile' },
];

export function LessonPipelineSidebar() {
  const { selectedStageId, setSelectedStageId, lessonRun } = useLessonContext();
  const runStages = lessonRun?.stages || [];

  return (
    <>
      {LESSON_STAGES.map((stage, index) => {
        const stageRecord = runStages.find((s) => s.stage_id === stage.id);
        const status: PipelineCardStatus =
          stageRecord?.status === 'succeeded' || stageRecord?.status === 'failed' || stageRecord?.status === 'running'
            ? stageRecord.status
            : 'pending';
        return (
          <PipelineCard
            key={stage.id}
            stageId={stage.id}
            number={String(index + 1)}
            name={stage.name}
            status={status}
            selected={selectedStageId === stage.id}
            cost={stageRecord?.total_cost_usd ? Number(stageRecord.total_cost_usd) : undefined}
            runCount={((stageRecord as { runs?: unknown[] } | undefined)?.runs?.length) || 0}
            onClick={() => setSelectedStageId(stage.id)}
          />
        );
      })}
    </>
  );
}
